






import { Component, Prop, Vue } from 'vue-property-decorator';
import { CompilationListItem } from '@/types';
import UCheckbox from '@/ui-lib/checkbox/Checkbox.vue';

@Component({
  components: {
    UCheckbox
  }
})
export default class TrackSelectCompilationsItem extends Vue {
  @Prop({ required: true })
  private compilation!: CompilationListItem;

  @Prop({ type: Array, default: () => [] })
  private selected!: number[];

  private get isSelected() {
    return this.selected.includes(this.compilation.id);
  }

  // Sets rather than toggles: the checkbox also emits when its value changes from outside
  // (a new selection on reopening), and toggling on that echo would flip the item back.
  private set isSelected(val: boolean) {
    const index = this.selected.indexOf(this.compilation.id);

    if (val && index === -1) {
      this.selected.push(this.compilation.id);
    } else if (!val && index >= 0) {
      this.selected.splice(index, 1);
    }
  }

  private get name(): string {
    return this.compilation.name;
  }
}
